module.exports = __webpack_public_path__ + "img/submit-h.fa72f3ee.png";